export const WORKSPACE_TYPE = {
  MY_WORKSPACE: "myWorkspace",
  ALL_WORKSPACE: "allWorkspace",
};
